// WHITE-LABEL: IDENTITY
// Client clones should change brand.meta.json and replace files in public/brand.
import meta from "./brand.meta.json";

const brand = Object.freeze({
  ...meta,
  assets: Object.freeze({
    logo: "/brand/logo.png",
    logoMark: "/brand/logo-mark.png",
    favicon: "/brand/logo-mark.png",
  }),
});

export default brand;
